import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router } from 'react-router-dom';

import { DeviceProvider } from 'components/providers/DeviceProvider';
import FeatureProvider from 'components/providers/FeatureProvider';
import GlobalStoreProvider from 'components/providers/GlobalStoreProvider';
import { ToastProvider } from 'components/providers/ToastProvider';

import AppRoutes from './AppRoutes';

export const App = () => (
    <GlobalStoreProvider>
        <IntlProvider defaultLocale='en' locale='en'>
            <DeviceProvider deskWidthPx='769px'>
                <FeatureProvider>
                    <Router>
                        <ToastProvider>
                            <AppRoutes />
                        </ToastProvider>
                    </Router>
                </FeatureProvider>
            </DeviceProvider>
        </IntlProvider>
    </GlobalStoreProvider>
);
